import { EFontWeight } from 'constants/enums';

import { CompletedThemeFormValues } from './types';

export const DEFAULT_CLOSE_ICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2352525b' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E";

export const defaultCompletedTheme: CompletedThemeFormValues = {
  purchaseCompletedModal: {
    color: {
      colorOne: 'white',
      colorTwo: ''
    },
    size: 44,
    text: 'Success',
    weight: EFontWeight.Bold
  },
  additionalText: {
    color: 'white',
    size: 24,
    text: 'Open the game to see yuor new items',
    weight: EFontWeight.Bold
  },
  productsQuantity: {
    color: 'white',
    size: 16,
    weight: EFontWeight.Regular
  },
  backgroundOpacity: 20,
  closeIcon: DEFAULT_CLOSE_ICON,
  backToGameButton: {
    image: '',
    text: 'Back to game'
  },
  deepLinks: {
    android: '',
    ios: '',
    web: ''
  }
};
